import type { MachineLookupItem } from '../api/types.ts';

/**
 * Maschinenliste auf dem Gerät (F21): Ohne Netz bliebe sonst nur „ohne Maschine“, und das Ticket liefe
 * über das Hauptwerk des Melders statt über die Maschine. Sie nennt keine Personen. Das Abmelden leert
 * sie trotzdem, das Gerät kann geteilt sein.
 */
const KEY = 'hd.machines';

export const MACHINE_LIST_MAX_AGE_MS = 24 * 3_600_000;

export function rememberMachines(items: MachineLookupItem[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify({ fetchedAt: Date.now(), items }));
  } catch {
    /* Speicher voll oder privater Modus: dann eben ohne Liste */
  }
}

export function rememberedMachines(): { fetchedAt: number; items: MachineLookupItem[] } | undefined {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as { fetchedAt: number; items: MachineLookupItem[] }) : undefined;
  } catch {
    return undefined;
  }
}

export function forgetMachines(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* privater Modus */
  }
}

const fold = (text: string) => text.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase();

/** Findet wie die Suche des Servers Teilwörter ohne Akzente. */
export function searchMachines(items: MachineLookupItem[], q: string, limit: number): MachineLookupItem[] {
  const terms = fold(q).split(/\s+/).filter(Boolean);
  return items
    .filter((m) => {
      const text = fold(`${m.name} ${m.inventoryNo} ${m.qrCode}`);
      return terms.every((term) => text.includes(term));
    })
    .slice(0, limit);
}
